<style lang="scss" scoped>
.slide-7 {
  background-image: url("../../../assets/module3/slide7/background-01.jpg");
  background-size: cover;
  background-position: center;
  height: calc(100% - 0px);
}

.page {
  padding-top: 80px;
}
.page-left {
  flex-basis: 55%;
}

.heading1,
.heading3,
.heading4 {
  color: #c5d43b;
}

.heading3 {
  margin-left: 50px;
}

.remember {
  color: #fff;
  font-size: 100px;
}

.heading6 {
  color: #3b7fc2;
  width: 700px;
}
.weak {
  position: relative;
  display: inline-block;
  transform: rotate(90deg);
  margin-left: 660px;
  margin-top: 50px;
}

.copy1 {
  width: 450px;
  margin-top: 120px;
  margin-left: 50px;
}
.page-right {
  position: relative;
}
.num-text {
  font-size: 40px;
  font-family: "Kookycat-FASTcaps";
  position: absolute;
  left: 300px;
  width: 40%;
  span {
    color: #e30614;
    display: block;
  }
  big {
    font-size: 140px;
    margin-bottom: -20px;
    line-height: 1;
    margin-top: 10px;
    display: block;
  }
}
</style>

<template>
  <div class="slide-7">
    <transition name="fadeLeft" appear>
      <img
        class="chars delay-1"
        v-show="slideIndex == 6"
        src="@/assets/module3/slide7/image-01.png"
      />
    </transition>
    <transition name="fadeRight" appear>
      <img
        class="chars delay-1"
        v-show="slideIndex == 6"
        src="@/assets/module3/slide7/text-01.png"
      />
    </transition>
    <transition name="fadeUp" appear>
      <img
        class="chars delay-2"
        v-show="slideIndex == 6"
        src="@/assets/module3/slide7/armando-01.png"
      />
    </transition>

    <div class="pages">
      <div class="page page-left">
        <transition name="fadeLeft" appear>
          <div class="delay-1" v-show="slideIndex == 6">
            <h1 class="heading1">
              {{ $t("module3.slide7.heading1") }}
              <span class="remember">{{ $t("module3.slide7.heading2") }}</span>
            </h1>
            <h1 class="heading3">{{ $t("module3.slide7.heading3") }}</h1>
            <h1 class="heading4">
              {{ $t("module3.slide7.heading4") }}
              <span class="weak">{{ $t("module3.slide7.heading5") }}</span>
            </h1>
          </div>
        </transition>
        <transition name="fadeLeft" appear>
          <div class="delay-2" v-show="slideIndex == 6">
            <h1 class="heading6">{{ $t("module3.slide7.heading6") }}</h1>
          </div>
        </transition>
        <transition name="fadeLeft" appear>
          <div class="delay-3" v-show="slideIndex == 6">
            <p class="copy1">{{ $t("module3.slide7.copy1") }}</p>
          </div>
        </transition>
      </div>
      <div class="page page-right">
        <transition name="fadeRight" appear>
          <div class="num-text delay-1" v-show="slideIndex == 6">
            <span>one</span>
            <big>arm</big>
            could suddenly become weak
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
